var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.327%",
    y1: "28.187%",
    x2: "61.695%",
    y2: "44.255%",
    id: "google-drive_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A46",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB572",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.762%",
    y1: "7.669%",
    x2: "50.303%",
    y2: "50.396%",
    id: "google-drive_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A59A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5079BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.533%",
    y1: "106.201%",
    x2: "58.369%",
    y2: "78.405%",
    id: "google-drive_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFA326",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCF4B",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h64v64H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.58.098L0 28.523 7.386 42l16.739-28.697z",
    fill: "url(#google-drive_svg__a)",
    transform: "translate(8 11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.458.212L.568 14h33.077L41.59.12z",
    transform: "translate(15 39)",
    fill: "url(#google-drive_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.671.078L16.865 27.9l15.724-.044L15.931.122z",
    transform: "translate(24 11)",
    fill: "url(#google-drive_svg__c)"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgeDE9Ijk1LjMyNyUiIHkxPSIyOC4xODclIiB4Mj0iNjEuNjk1JSIgeTI9IjQ0LjI1NSUiIGlkPSJhIj48c3RvcCBzdG9wLWNvbG9yPSIjMDA4QTQ2IiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iIzJCQjU3MiIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgeDE9IjE3Ljc2MiUiIHkxPSI3LjY2OSUiIHgyPSI1MC4zMDMlIiB5Mj0iNTAuMzk2JSIgaWQ9ImIiPjxzdG9wIHN0b3AtY29sb3I9IiMzQTU5QTgiIG9mZnNldD0iMCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjNTA3OUJDIiBvZmZzZXQ9IjEwMCUiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCB4MT0iNjYuNTMzJSIgeTE9IjEwNi4yMDElIiB4Mj0iNTguMzY5JSIgeTI9Ijc4LjQwNSUiIGlkPSJjIj48c3RvcCBzdG9wLWNvbG9yPSIjREZBMzI2IiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iI0ZEQ0Y0QiIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMCAwaDY0djY0SDB6Ii8+PHBhdGggZD0iTTE2LjU4LjA5OEwwIDI4LjUyMyA3LjM4NiA0MmwxNi43MzktMjguNjk3eiIgZmlsbD0idXJsKCNhKSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOCAxMSkiLz48cGF0aCBkPSJNOC40NTguMjEyTC41NjggMTRoMzMuMDc3TDQxLjU5LjEyeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUgMzkpIiBmaWxsPSJ1cmwoI2IpIi8+PHBhdGggZD0iTS42NzEuMDc4TDE2Ljg2NSAyNy45bDE1LjcyNC0uMDQ0TDE1LjkzMS4xMjJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNCAxMSkiIGZpbGw9InVybCgjYykiLz48L2c+PC9zdmc+";
export { SvgGoogleDrive as ReactComponent };